import instance from 'utils/axios/instance.axios';
import { LIQUIDATION_REVIEW } from './_constant';

export default {};
export const getReviewerInfo = (projectProposalId, councilId) =>
  instance.get(LIQUIDATION_REVIEW.GET_REVIEWER_INFO, {
    params: { projectProposalId, councilId },
  });
